import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class TimestampEmptyValue extends BaseOption {
  static userInterfaceComponent = {
    label: "Value meaning no date",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = -1;
}
